import { Component, OnInit } from '@angular/core';
import { ColumnMode } from "@swimlane/ngx-datatable";
import { IconversionFilter, IDropdownListPublisher, IpublisherPage, Page } from 'src/app/shared/filters/filters';
import { FinanceService } from '../../../../shared/services/admServices/finance.service';
import { AccountService } from '../../../../shared/services/admServices/accounts.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'adm-conv-component',
  templateUrl: './conv-component.html',
  styleUrls: ['./conv-component.scss']
})

export class finconversionsComponent implements OnInit {
  today: Date;
  fromDate: any;
  toDate: any;
  DateMax: any;
  btnName: any;
  btnColor: any;
  btnOn: any = false;
  filter : IconversionFilter = { pageNumber:1, pageSize:40 };
  page = new Page();
  publisherPage : IpublisherPage = { pageNumber:1, pageSize:40, isAdminWithPublisherAccountIncluded:true };

  offsetNumber: number;
  pageSizeDefinition = 40;

  dropdownListStatus : any[] = [];
  selectedItemsStatus : any[] = [];
  dropdownSettingsStatus: any = {};
  dropdownListPublisher : Array<IDropdownListPublisher> = [{item_id: 0, item_text:""},];

  selectedItemsPublisher : any[] = [];
  dropdownSettingsPublisher: any = {};

  conversionData: any;
  publisherData: any;

  ColumnMode = ColumnMode;

  constructor(private financeService: FinanceService, private accountService: AccountService,private toastrService: ToastrService) {
    this.DateMax = new Date().toISOString().split('T')[0];
    this.btnName = "Filter";
    this.btnColor = "btn-info";

    this.offsetNumber = 0;
    this.page.pageNumber = 1;
    this.page.size = this.pageSizeDefinition;
   }

  ngOnInit() {
    this.dropdownListStatus = [
      { item_id: 1, item_text: 'Pending' },
      { item_id: 3, item_text: 'Paid' },
      { item_id: 2, item_text: 'Reversed' }
    ];
    this.dropdownSettingsStatus = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: false
    };
    // get Publishers
    this.getPublishers();
    this.dropdownSettingsPublisher = {
        singleSelection: false,
        idField: "item_id",
        textField: "item_text",
        selectAllText: "Select All",
        unSelectAllText: "UnSelect All",
        itemsShowLimit: 1,
        allowSearchFilter: true
      };

      this.setSelected();

      if(this.financeService.getFilter(5)){
        // filter is ON
        this.btnName = "Filter";
        this.btnColor = "btn-danger";
        this.btnOn = true;
      }

      this.setPage({ offset: this.financeService.getFilter(6) });
  }

  getPublishers(){
    // API pobrania listy publisherów
    this.accountService.getAllPublishers(this.publisherPage)
    .subscribe(
     data => {
      this.dropdownListPublisher = [];
      data.data.publishers.forEach((value, index) => {
        this.dropdownListPublisher.push({item_id: value.id, item_text: value.firstName + " " + value.lastName});
      });

     },
     error => {
       console.log(error);
     });

  }

  setPage(pageInfo){
    this.filter.pageNumber = pageInfo.offset+1;
    this.filter.pageSize = this.pageSizeDefinition;
    this.financeService.saveFilter(6, pageInfo.offset);

    this.financeService.getAllConversion(this.filter)
    .subscribe(
     data => {
      this.page.totalElements = data.totalRecords;
      this.page.totalPages = data.totalPages;
      this.page.pageNumber = data.pageNumber-1;
      this.conversionData = data.data;
     },
     error => {
       console.log(error);
     });

  }

  setSelected(){
    this.selectedItemsStatus = this.financeService.getFilter(1);
    if(this.selectedItemsStatus==null)
      {
          this.selectedItemsStatus = [
          ];
          this.financeService.saveFilter(1, this.selectedItemsStatus);
      }

      this.selectedItemsPublisher = this.financeService.getFilter(2);
      if(this.selectedItemsPublisher==null)
      {
          this.selectedItemsPublisher = [
          ];
          this.financeService.saveFilter(2, this.selectedItemsPublisher);
      }

      this.fromDate = this.financeService.getFilter(3);
      this.toDate = this.financeService.getFilter(4);

      this.offsetNumber = 0;// rzeczywisty numer strony jest offsetNumber+1, 0 odpowiada pierwszej stronie
      this.setFilter();
  }

  setFilter(){
    // filtr Status
    delete this.filter.conversionStatuses;
    if(this.selectedItemsStatus.length>0)
      {
        // coś zostało wybrane lub coś jest ustawione
        this.filter.conversionStatuses= [];
        for(var i=0; i<this.selectedItemsStatus.length; i++)
          this.filter.conversionStatuses[i] = this.selectedItemsStatus[i].item_id;
        this.financeService.saveFilter(1, this.selectedItemsStatus);
      }

    delete this.filter.publishers;
    if(this.selectedItemsPublisher.length>0)
      {
        // coś zostało wybrane lub coś jest ustawione
        this.filter.publishers= [];
        for(var i=0; i<this.selectedItemsPublisher.length; i++)
          this.filter.publishers[i] = this.selectedItemsPublisher[i].item_id;
        this.financeService.saveFilter(2, this.selectedItemsPublisher);
      }

    delete this.filter.startDate;
    if(this.fromDate!=null && this.fromDate!="")
    {
      var startDate: Date;
      startDate = new Date(this.fromDate);
      var isoDateStart = new Date(startDate.getTime() + startDate.getTimezoneOffset() * 60000).toISOString();
      this.filter.startDate = isoDateStart;
      this.financeService.saveFilter(3, this.fromDate);
    }

    delete this.filter.endDate;
    if(this.toDate!=null && this.toDate!="")
    {
      var endDate: Date;
      endDate = new Date(this.toDate);
      endDate.setHours(endDate.getHours() + 24);
      var isoDateEnd = new Date(endDate.getTime() + endDate.getTimezoneOffset() * 60000).toISOString();
      this.filter.endDate = isoDateEnd;
      this.financeService.saveFilter(4, this.toDate);
    }
  }

  onFilter(){
    // wartość "" jest ustawiana gdy w dropdown liście daty zostanie użyta funkcja 'wyczyść'
    if(this.fromDate=="")
    {
      this.fromDate=null;
      this.financeService.saveFilter(3, this.fromDate);
    }
    if(this.toDate=="")
    {
      this.toDate=null;
      this.financeService.saveFilter(4, this.toDate);
    }

    if(this.toDate<this.fromDate)
      this.toastrService.error('End date can not be before start date, please correct.', 'Error !');
    else
    {
      // filter is ON
      this.btnName = "Filter";
      this.btnColor = "btn-danger";
      this.btnOn = true;
      this.financeService.saveFilter(5, this.btnOn);

      this.setFilter();
      this.setPage({ offset: 0 });
    }
    // różnica, jak więcej dni tdo tyłu to 24x coś tam
    // var today = new Date('October 13, 2014 22:34:17');
    // var yesterday = new Date(today.getTime() - (24*60*60*1000));
    // console.log(yesterday);

    // -- lub
    // var d = new Date(); // today!
    // var x = 5; // go back 5 days!
    // d.setDate(d.getDate() - x);

    // -- lub
    // var dateOffset = (24*60*60*1000) * 5; //5 days
    // var myDate = new Date();
    // myDate.setTime(myDate.getTime() - dateOffset);
  }

  onClear(){
    // filter is OFF and default parameters are used
    this.btnName = "Filter";
    this.btnColor = "btn-info";
    this.btnOn = false;
    this.financeService.saveFilter(5, this.btnOn);

    this.selectedItemsStatus = [
    ];
    this.financeService.saveFilter(1, this.selectedItemsStatus);

    this.selectedItemsPublisher = [
    ];
    this.financeService.saveFilter(2, this.selectedItemsPublisher);

    this.fromDate = null;
    this.financeService.saveFilter(3, this.fromDate);
    this.toDate = null;
    this.financeService.saveFilter(4, this.toDate);

    delete this.filter.conversionStatuses;
    delete this.filter.publishers;
    delete this.filter.startDate;
    delete this.filter.endDate;
    this.filter.pageNumber = 1;
    this.filter.pageSize = this.pageSizeDefinition;

    this.setFilter();
    this.setPage({ offset: 0 });
  }

  onItemSelect(item: any) {
    //console.log("onItemSelect", item);
  }
  onSelectAll(items: any) {
    //console.log("onSelectAll", items);
  }
  onItemSelectPublisher(item: any) {
    //console.log("onItemSelect", item);
  }
  onSelectAllPublisher(items: any) {
    //console.log("onSelectAll", items);
  }

}
